var React = require('react');

function Remove (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M19.5 7.5h-15v0c-.28 0-.5.22-.5.5v14 0c0 1.1.89 2 2 2h12v0c1.1 0 2-.9 2-2V8v0c0-.28-.23-.5-.5-.5Zm-9.25 13v0c0 .41-.34.75-.75.75 -.42 0-.75-.34-.75-.75v-9 0c0-.42.33-.75.75-.75 .41 0 .75.33.75.75Zm5 0v0c0 .41-.34.75-.75.75 -.42 0-.75-.34-.75-.75v-9 0c0-.42.33-.75.75-.75 .41 0 .75.33.75.75Z","key":0}),React.createElement("path",{"d":"M22 4h-4.75v0c-.14 0-.25-.12-.25-.25V2.5v0C17 1.11 15.88 0 14.5 0h-5v0C8.11 0 7 1.11 7 2.5v1.25 0c0 .13-.12.25-.25.25H2v0c-.56 0-1 .44-1 1 0 .55.44 1 1 1h20v0c.55 0 1-.45 1-1 0-.56-.45-1-1-1ZM9 3.75V2.5v0c0-.28.22-.5.5-.5h5v0c.27 0 .5.22.5.5v1.25 0c0 .13-.12.25-.25.25h-5.5v0C9.11 4 9 3.88 9 3.75Z","key":1})]));
}

Remove.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Remove;

Remove.default = Remove;
